import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss',
})
export class VerifyEmailComponent {
  userService = inject(UserService);

  logout = () => {
    this.userService.logout().then(() => {
      this.userService.redirectToLogin('/quotes');
    });
  };
}
